import React, { useState, useEffect } from 'react';
import './PaymentMethodSelector.css';

const PaymentMethodSelector = ({ 
  selectedMethod, 
  onMethodChange, 
  pricing, 
  disabled = false,
  showPricing = true 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const paymentMethods = [
    {
      id: 'cash',
      name: 'Cash Payment',
      description: 'Pay cash to helper after service completion',
      icon: '💵',
      color: '#28a745',
      features: []
    },
    {
      id: 'online',
      name: 'Online Payment',
      description: 'Pay securely online via UPI, Cards, Wallets',
      icon: '💳',
      color: '#007bff',
      features: ['Secure payment', 'Multiple options']
    }
  ];

  const formatCurrency = (amount) => {
    return `₹${amount}`;
  };

  return (
    <div className="payment-method-selector">
      <h3>Choose Payment Method</h3>
      
      <div className="payment-methods">
        {paymentMethods.map(method => (
          <div
            key={method.id}
            className={`payment-method ${selectedMethod === method.id ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
            onClick={() => !disabled && onMethodChange(method.id)}
          >
            <div className="method-header">
              <div className="method-icon" style={{ color: method.color }}>
                {method.icon}
              </div>
              <div className="method-info">
                <div className="method-name">{method.name}</div>
                <div className="method-description">{method.description}</div>
              </div>
              <div className="method-selection">
                <div className={`radio-button ${selectedMethod === method.id ? 'selected' : ''}`}>
                  {selectedMethod === method.id && <div className="radio-dot"></div>}
                </div>
              </div>
            </div>
            
            <div className="method-features">
              {method.features.map((feature, index) => (
                <span key={index} className="feature-tag">
                  ✓ {feature}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {showPricing && pricing && (
        <div className="pricing-breakdown">
          <div 
            className="pricing-header"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <h4>Bill Details</h4>
            <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
              ▼
            </span>
          </div>
          
          <div className={`pricing-details ${isExpanded ? 'expanded' : ''}`}>
            <div className="pricing-row">
              <span>Service Amount</span>
              <span>{formatCurrency(pricing.baseAmount)}</span>
            </div>
            
            <div className="pricing-row">
              <span>Platform Fee (5%)</span> 
              <span>{formatCurrency(pricing.platformFee)}</span>
            </div>
            
            {pricing.paymentProcessingFee > 0 && (
              <div className="pricing-row processing-fee">
                <span>Payment Processing Fee (2%)</span>
                <span>{formatCurrency(pricing.paymentProcessingFee)}</span>
              </div>
            )}
            
            <div className="pricing-divider"></div>
            
            <div className="pricing-row total">
              <span>Total Amount</span>
              <span>{formatCurrency(pricing.totalAmount)}</span>
            </div>
            
            {selectedMethod === 'cash' && pricing.paymentProcessingFee > 0 && (
              <div className="savings-note">
                💰 You save {formatCurrency(pricing.paymentProcessingFee)} with cash payment!
              </div>
            )}
          </div>
        </div>
      )}

      {selectedMethod === 'online' && (
        <div className="online-payment-info">
          <div className="payment-options">
            <h5>Supported Payment Methods:</h5>
            <div className="payment-icons">
              <span className="payment-icon">📱 UPI</span>
              <span className="payment-icon">💳 Cards</span>
              <span className="payment-icon">🏦 Net Banking</span>
              <span className="payment-icon">💼 Wallets</span>
            </div>
          </div>
          
          <div className="security-note">
            🔒 Secured by Razorpay - Your payment information is encrypted and secure
          </div>
        </div>
      )}

      {selectedMethod === 'cash' && (
        <div className="cash-payment-info">
          <div className="cash-instructions">
            <h5>Cash Payment Instructions:</h5>
            <ul>
              <li>Pay the helper directly after service completion</li>
              <li>Ensure you have exact amount ready</li>
              <li>Get confirmation from helper before payment</li>
              <li>Rate and review after successful payment</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodSelector; 